export const MissingPrice = 'MissingPrice'
export const OutOfStock = 'OutOfStock'
